import BaseApi from './baseApi';
import IInboundPicture from '../models/IInboundPicture';
import IAuthentication from '../models/IAuthentication';
export default class InboundPictureApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundPictures(idInbound: string) : Promise<IInboundPicture[]> {
        let json : string = this.getJsonRead(idInbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundPictures: IInboundPicture[] = [];
            inboundPictures = response.data as IInboundPicture[];
            return inboundPictures;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundPicture(inboundPicture: IInboundPicture) : Promise<string> {
        const json = this.getJsonSave(inboundPicture);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundPicture(inboundPicture: IInboundPicture) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundPicture);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundPicture(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteInboundPictureByInboundId(inboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByInboundId(inboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByInboundId(inboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsPictures",
            "conditions": [{
                "Item1": "InboundsPictures",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": inboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsPictures",
            "conditions": [{
                "Item1": "InboundsPictures",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundPicture: IInboundPicture) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "URL",
                "Item2": inboundPicture.url
            }, {
                "Item1": "idCompany",
                "Item2": inboundPicture.idCompany
            }, {
                "Item1": "idInbound",
                "Item2": inboundPicture.idInbound
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsPictures"
        };
        return json;
    }

    private getJsonUpdate(inboundPicture: IInboundPicture) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "URL",
                "Item2": inboundPicture.url
            }, {
                "Item1": "idCompany",
                "Item2": inboundPicture.idCompany
            }, {
                "Item1": "idInbound",
                "Item2": inboundPicture.idInbound
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsPictures",
            "keyvalue": inboundPicture.id
        };
        return json;
    }

    private getJsonRead(idInbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsPictures",
                "Item2": "id"
            }, {
                "Item1": "InboundsPictures",
                "Item2": "url"
            }, {
                "Item1": "InboundsPictures",
                "Item2": "idInbound"
            }, {
                "Item1": "InboundsPictures",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "InboundsPictures"
            }],
            "conditions": [{
                "Item1": "InboundsPictures",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsPictures",
                "Item2": "idInbound",
                "Item3": "=",
                "Item4": idInbound
            }]
        };
        return json;
    }
}
